import deephowApiServerWrapper from "@/server/api-server";

export const postCreateOrUpdateAnnotation = (payload) =>
  deephowApiServerWrapper("post", "/v1/annotations/batch-upsert", payload);

export const postFetchMultipleAnnotations = (stepIds = []) =>
  deephowApiServerWrapper("post", "/v1/annotations/get-by-steps", { stepIds });
